module.exports = __webpack_public_path__ + "bec4ec6229205a5e54143a6ca322e541.png";